module.exports = __webpack_public_path__ + "media/images/team_membership_payment_illustration-437a5b1083fb84779c2a983f47ded1c0.png";